import { useVisibilityForLegacyUrl } from '~/components/LegacyAppRouting/components/Learner';
import globalEnv from '~/config/env';

export function useSidebarVisibility() {
  const isVisibleForLegacyUrl = useVisibilityForLegacyUrl(
    globalEnv.LEGACY_WHITELISTED_SIDEBAR_ROUTES
  );

  return isVisibleForLegacyUrl;
}
